import {Link} from "react-router-dom";
import {useModal} from "@/context/ModalContext";
import heroImg from "@/assets/images/hero-granite.png";
import heroWebp from "@/assets/images/hero-granite.webp";
import heroAvif from "@/assets/images/hero-granite.avif";
import heroWebpSm from "@/assets/images/hero-granite-640.webp";
import heroAvifSm from "@/assets/images/hero-granite-640.avif";
import {yearsOfExperience} from "@/utils/companyInfo";

const trustItems = [
	"Власне виробництво",
	"Гарантія 10 років",
	"Безкоштовна консультація",
];

export default function HeroSection() {
	const {open} = useModal();

	return (
		<section className="hero">
			<div className="hero-mobile-bg" aria-hidden="true">
				<picture>
					<source srcSet={`${heroAvifSm} 640w, ${heroAvif} 1200w`} type="image/avif" sizes="100vw" />
					<source srcSet={`${heroWebpSm} 640w, ${heroWebp} 1200w`} type="image/webp" sizes="100vw" />
					<img
						src={heroImg}
						alt=""
						width="1024"
						height="1536"
						decoding="async"
						fetchpriority="high"
					/>
				</picture>
			</div>

			<div className="hero-content-region">
				<div className="hero-content">
					<p className="hero-kicker anim">
						Пам&apos;ять, вкарбована у вічний камінь
					</p>

					<h1 className="h1-hero anim anim-d1">
						Майстерня<br />
						кам&apos;яних<br />
						виробів
					</h1>

					<div className="hero-divider anim anim-d2" />

					<p className="hero-lead anim anim-d2">
						Понад {yearsOfExperience} років ми створюємо пам&apos;ятники з натурального каменю,
						які зберігають пам&apos;ять про найдорожчих людей на віки.
						Індивідуальний підхід, власне виробництво, гарантія якості.
					</p>

					<div className="hero-ctas anim anim-d3">
						<button className="btn btn-gold" onClick={open}>
							Замовити розрахунок
						</button>
						<Link to="/catalog" className="btn btn-navy">
							Переглянути каталог
						</Link>
					</div>

					<div className="hero-trust anim anim-d4">
						{trustItems.map((t) => (
							<span key={t} className="hero-trust-item">
								{t}
							</span>
						))}
					</div>
				</div>
			</div>

			<div className="hero-img">
				<picture>
					<source srcSet={heroAvif} type="image/avif" />
					<source srcSet={heroWebp} type="image/webp" />
					<img
						src={heroImg}
						alt="Гранітний пам'ятник на могилу, власне виробництво Ямпіль"
						width="1024"
						height="1536"
						decoding="async"
						fetchpriority="high"
					/>
				</picture>
			</div>
		</section>
	);
}
